export enum BUS_STOP_CODES {
  /** 広小路本町 */
  hirokojihonmachi_7 = 'hirokojihonmachi_7',
  /** 納屋橋 */
  nayabashi_2 = 'nayabashi_2',
  /** 高蔵寺 */
  kozoji = 'kozoji',
}
